import type { ReactNode } from "react";
import { Button, Modal } from "react-bootstrap";
import Loader from "@/components/common/loader/loader";

interface ConfirmBannerModalProps {
    show: boolean;
    busy?: boolean;
    title: string;
    body: ReactNode;
    /** The danger button, after Cancel. */
    actionLabel: string;
    onCancel: () => void;
    onConfirm: () => void;
}

/** The banner confirms (Turn Off, Delete): neutral Cancel, then the danger action (MPN-2171 design). */
export default function ConfirmBannerModal({ show, busy, title, body, actionLabel, onCancel, onConfirm }: ConfirmBannerModalProps) {
    const titleId = `confirm-banner-${actionLabel.toLowerCase().replace(/\s+/g, "-")}-title`;
    return (
        <Modal centered show={show} onHide={onCancel} aria-labelledby={titleId}>
            <Modal.Header closeButton>
                <Modal.Title id={titleId}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {busy && <Loader />}
                <p className="mb-0">{body}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" variant="neutral" onClick={onCancel} disabled={busy}>Cancel</Button>
                <Button type="button" variant="danger" onClick={onConfirm} disabled={busy}>{actionLabel}</Button>
            </Modal.Footer>
        </Modal>
    );
}
